// Design Ref: Option B — 가시성+포커스 트리거 + 60초 인터벌
// SPA에서 페이지 머무는 동안에도 미확인 알림을 자연스럽게 갱신
import { browser } from '$app/environment';

const DEFAULT_INTERVAL_MS = 60_000;

// shouldRun: 호출 시점에 폴링이 유효한지(예: 로그인 상태) 판단하는 함수
// checkFns: 호출할 비동기 함수들의 배열
// 반환값: cleanup 함수
export function startUnreadPolling(checkFns, shouldRun, { intervalMs = DEFAULT_INTERVAL_MS } = {}) {
	if (!browser) return () => {};

	const runAll = () => {
		if (!shouldRun()) return;
		for (const fn of checkFns) fn();
	};

	const onVisibilityChange = () => {
		if (document.visibilityState === 'visible') runAll();
	};

	document.addEventListener('visibilitychange', onVisibilityChange);
	window.addEventListener('focus', runAll);
	const intervalId = setInterval(runAll, intervalMs);

	return () => {
		document.removeEventListener('visibilitychange', onVisibilityChange);
		window.removeEventListener('focus', runAll);
		clearInterval(intervalId);
	};
}
